import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';
import {
  UserInteractor,
  UserInteractorType,
  WorkTableType,
} from '../UserInteractor';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

export class OpenWorkCalendarCommand extends CategoryCommand<void> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.SET_CALENDAR_WORK,
    };
  }

  public getIcon(): IconName {
    return 'calendar';
  }

  public isAvailable(context: ClientContext): boolean {
    return context.has('Id');
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NONE;
  }

  public async getUserInteractor(): Promise<UserInteractor> {
    return {
      type: UserInteractorType.WORK_TABLE,
      tableType: WorkTableType.CALENDAR,
    };
  }

  public getName(): CommandName {
    return 'openWorkCalendar';
  }
}
